import StarIcon from '@mui/icons-material/Star';
import { Avatar, Box, Grid, Paper, Stack, Typography } from '@mui/material';

// All testimonial content lives here — add/remove/edit entries and the grid updates itself
const testimonials = [
  {
    name: 'Warren Roach',
    role: 'Fleet Owner | California | Jul 2026',
    rating: 5,
    text: "I really liked TaxZerone's Form 2290 Bulk Upload feature. It made filing multiple trucks simple and saved me a lot of time.",
    helpful: 39,
  },
  {
    name: 'Kevin Kent',
    role: 'Truck Owner | California | Jul 2026',
    rating: 5,
    text: 'Thanks to TaxZerone for the timely Form 2290 reminder. I received the notification at the right time and was able to complete my filing before the deadline. Great service and very helpful!',
    helpful: 21,
  },
  {
    name: 'Warren Roach',
    role: 'Owner-Operator | Texas | Jul 2026',
    rating: 5,
    text: "I had a great experience with TaxZerone's Form 2290 phone filing service. The support team was quick to respond and guided me through the process. After sharing my truck details, everything was completed within minutes, and my Schedule 1 was delivered promptly. Excellent service!",
    helpful: 92,
  },
  {
    name: 'Luis Echenique',
    role: 'Grants Director | Alaska | June 2026',
    rating: 5,
    text: 'OMG! I cannot believe how wonderful the live support was. The agent Alexia assisted me with everything I needed and fixed all the issues in the most professional and friendly manner. Amazing customer experience. Thank You!',
    helpful: 39,
  },
  {
    name: 'Kristin Patterson',
    role: 'Employer | Texas | Jun 2026',
    rating: 5,
    text: 'Early filed Form 941 Q2 this time. Honestly just wanted to avoid the last-minute headache—and it worked. Thanks, TaxZerone!',
    helpful: 12,
  },
  {
    name: 'Marcus Reynolds',
    role: 'Owner-Operator | Texas | Jun 2026',
    rating: 5,
    text: "I usually wait until the last minute, but this year I pre-filed my Form 2290 with TaxZerone. It only took a few minutes, and now I don't have to worry about the deadline.",
    helpful: 42,
  },
  {
    name: 'Brandy Falconer',
    role: 'Fleet Owner | California | Jun 2026',
    rating: 5,
    text: 'Received the pre-filing reminder email and filed my Form 2290 early with no deadline stress - thanks, everything was quick & easy.',
    helpful: 13,
  },
  {
    name: 'Todd Anderson',
    role: 'Executive Director | California | Jun 2026',
    rating: 5,
    text: 'As a first-time filer, I found TaxZerone very easy to use. The platform guided me through each section, and my form 990 was accepted by the IRS on the first try.',
    helpful: 26,
  },
  {
    name: 'David Wimmer',
    role: 'Owner-Operator | California | Jun 2026',
    rating: 5,
    text: 'This was my first time filing Form 2290 in advance, and TaxZerone made the whole experience simple and convenient. Highly recommended!',
    helpful: 65,
  },
  {
    name: 'Richard Toker',
    role: 'Fleet Owner | Kansas | Jun 2026',
    rating: 5,
    text: "I didn't have to enter all my information again. TaxZerone pulled my previous year's data and filled out my new Form 2290 automatically. Huge time-saver!",
    helpful: 30,
  },
  {
    name: 'Robert C Clark',
    role: 'Board Treasurer | Florida | May 2026',
    rating: 5,
    text: 'TaxZerone made my Form 990-EZ filing incredibly easy. The easy guidance walked me through every field, and my return was accepted by the IRS without any issues.',
    helpful: 11,
  },
  {
    name: 'J E Williams',
    role: 'Nonprofit Administrator | New York | May 2026',
    rating: 5,
    text: 'I had a good experience filing Form 990. Everything was laid out clearly, and whenever I had questions, the chat agent responded quickly and guided me through it.',
    helpful: 52,
  },
  {
    name: 'Matthew Baker',
    role: 'Foundation Manager | California | Jun 2026',
    rating: 5,
    text: "I didn't expect California state filing to be this easy. I was able to file Form 199 quickly without needing much help.",
    helpful: 8,
  },
  {
    name: 'Elizabeth Wagner',
    role: 'President | New York | May 2026',
    rating: 5,
    text: 'The phone support team was really patient and walked me through everything step by step. I had no tax knowledge at all going in. TaxZerone made the whole process feel easy and gave me confidence. 10/10.',
    helpful: 13,
  },
  {
    name: 'Joseph J Perez',
    role: 'Fleet Owner | California | Jun 2026',
    rating: 5,
    text: "Really good chat support experience. I wasn't sure how to complete a few steps, but Kevin guided me clearly and stayed with me until everything was done. Appreciate the help.",
    helpful: 10,
  },
  {
    name: 'Lesley Hazleton',
    role: 'Tax Preparer | Kansas | April 2025',
    rating: 5,
    text: 'This tax solution is exactly what I was looking for. I am not doing a lot of tax preparation, but my clients really want me to do their taxes instead of finding another preparer. This solution is perfect. I especially love the almost instant feedback with the extensions. This will save me lots of headaches.',
    helpful: 21,
  },
  {
    name: 'Carol Jennings',
    role: 'President | Oregon | May 2026',
    rating: 5,
    text: 'Your company is the best! Alexia has been so helpful again. Thank you!',
    helpful: 18,
  },
  {
    name: 'Yuriy Shklyar',
    role: 'Director | Wyoming | Mar 2026',
    rating: 5,
    text: 'Thank you for providing such a smooth and intuitive experience for filing Form 7004 on your website. The step-by-step guidance and clear interface made the entire process fast, simple, and stress-free.',
    helpful: 42,
  },
];

// Rotates through a small palette so avatars aren't all the same color
const avatarColors = [
  '#1155cc',
  '#d32f2f',
  '#2e7d32',
  '#f57c00',
  '#6a1b9a',
  '#00838f',
  '#c2185b',
];

function TestimonialCard({
  testimonial,
  avatarColor,
}: {
  testimonial: (typeof testimonials)[0];
  avatarColor: string;
}) {
  // const { ref, inView } = useInView({
  //   triggerOnce: true, // Animate only once
  //   threshold: 0.8, // Start when 80% is visible
  // });

  // const [liked, setLiked] = useState(false);
  // const [likes, setLikes] = useState(testimonial.helpful);

  // const handleLike = () => {
  //   setLiked(!liked);
  //   setLikes(liked ? likes - 1 : likes + 1);
  // };

  return (
    <Paper
      // ref={ref}
      elevation={0}
      sx={{
        p: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 4,
        border: '3px solid #e5e7eb',
        // opacity: inView ? 1 : 0,
        // transform: inView ? 'translateY(0)' : 'translateY(20px)',
        // transition:
        //   'opacity 0.6s ease, transform 0.6s ease, border-color 0.3s ease, border-radius 0.3s ease',
        '&:hover': {
          borderColor: 'primary.main',
          borderRadius: 5.5,
        },
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Avatar sx={{ bgcolor: avatarColor }}>
          {testimonial.name.charAt(0)}
        </Avatar>
        <Box>
          <Typography fontWeight={700}>{testimonial.name}</Typography>
          <Typography variant="body2" color="text.secondary">
            {testimonial.role}
          </Typography>
        </Box>
      </Stack>

      {testimonial.rating ? (
        <Stack direction="row" spacing={0.3} sx={{ mt: 2 }}>
          {[...Array(testimonial.rating)].map((_, i) => (
            <StarIcon key={i} sx={{ color: '#FFC107', fontSize: 20 }} />
          ))}
        </Stack>
      ) : (
        <Box sx={{ mt: 2 }} />
      )}

      <Typography sx={{ mt: 2, lineHeight: 1.8 }}>
        {testimonial.text}
      </Typography>

      {/* <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ mt: 'auto', pt: 2 }}
      >
        <IconButton
          onClick={handleLike}
          sx={{
            color: liked ? 'primary.main' : 'text.secondary',
            transition: 'all 0.3s ease',
            '& svg': { fontSize: 28, transition: 'all 0.3s ease' },
            ...(liked && { animation: 'pop 0.35s ease' }),
            '@keyframes pop': {
              '0%': { transform: 'scale(1)' },
              '50%': { transform: 'scale(1.3)' },
              '100%': { transform: 'scale(1)' },
            },
          }}
        >
          {liked ? (
            <ThumbUpAltIcon sx={{ color: 'primary.main' }} />
          ) : (
            <ThumbUpOffAltIcon sx={{ color: 'text.secondary' }} />
          )}
        </IconButton>
        <Typography
          sx={{
            fontWeight: 600,
            color: liked ? '#1155cc' : '#555',
            transition: 'color .3s ease',
          }}
        >
          Helpful ({likes})
        </Typography>
      </Stack> */}
    </Paper>
  );
}

export default function TestimonialsGrid() {
  return (
    <Grid container spacing={3}>
      {testimonials.map((testimonial, idx) => (
        <Grid
          size={{ xs: 12, sm: 6, md: 4 }}
          key={`${testimonial.name}-${idx}`}
        >
          <TestimonialCard
            testimonial={testimonial}
            avatarColor={avatarColors[idx % avatarColors.length]!}
          />
        </Grid>
      ))}
    </Grid>
  );
}
